const STALE_ASSET_RELOAD_KEY = 'frankfurtplus:stale_asset_reloaded'
let reloadedInMemory = false

export function recoverFromStaleAssets(): void {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    reloadOnce()
  })

  window.addEventListener(
    'error',
    (event) => {
      if (!(event.error instanceof SyntaxError) || !event.filename) {
        return
      }

      const filename = new URL(event.filename, window.location.href)
      const isCurrentDocumentParsedAsScript =
        filename.origin === window.location.origin &&
        filename.pathname === window.location.pathname &&
        event.message.includes('Unexpected token')

      if (!isCurrentDocumentParsedAsScript) return

      event.preventDefault()
      reloadOnce()
    },
    true,
  )
}

function reloadOnce(): void {
  if (reloadedInMemory) {
    return
  }

  try {
    if (sessionStorage.getItem(STALE_ASSET_RELOAD_KEY) === window.location.pathname) {
      return
    }
  } catch {
    // Storage can be unavailable in restricted WebViews; the in-memory guard still prevents loops.
  }

  // A stale deploy can make Vite request the HTML page as a JS chunk.
  reloadedInMemory = true

  try {
    sessionStorage.setItem(STALE_ASSET_RELOAD_KEY, window.location.pathname)
  } catch {
    // Storage can be unavailable in restricted WebViews; the in-memory guard still prevents loops.
  }

  window.location.reload()
}
